import { useLang } from "@/lib/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [
    t.hero.eyebrow,
    t.announce.split(" · ")[0],
    t.announce.split(" · ")[1],
    "MIORA — miora-boutique.com",
  ];
  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className="px-10 text-[10px] uppercase tracking-[0.26em] whitespace-nowrap text-ink/45">{it}</span>
          <span className="w-1 h-1 rounded-full bg-rose/60 shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="bg-ivory border-y border-ink/10 marquee-mask py-4" dir="ltr" data-testid="marquee-band">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
